import { Component, OnInit, ViewChild } from '@angular/core';
import {LanguageService} from '../../language.service';
import { CarouselComponent } from 'src/app/layout/carousel/carousel.component';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent  {
  @ViewChild(CarouselComponent, { static: false }) c: CarouselComponent;
  constructor(public languageService: LanguageService) { }

  prev() {
    this.c.prev();
  }
  next() {
    this.c.next();
  }
}
